export default __webpack_public_path__ + "static/media/music-img.bf86081d.png";